export default __webpack_public_path__ + "static/media/heavy_machinery_parts_dealers.31c897d8.png";